import { SortingFn } from "@tanstack/react-table";

export const dateSortingFn: SortingFn<any> = (rowA, rowB, columnId) => {
    const dateA = new Date(rowA.getValue(columnId) as string);
    const dateB = new Date(rowB.getValue(columnId) as string);

    const timeA = dateA.getTime();
    const timeB = dateB.getTime();

    if (isNaN(timeA) || isNaN(timeB)) {
        // Fallback for invalid dates (e.g., place invalid dates last)
        if (isNaN(timeA) && isNaN(timeB)) return 0;
        if (isNaN(timeA)) return 1; // A is invalid, push to end
        return -1; // B is invalid, push to end
    }

    if (timeA > timeB) return 1;
    if (timeA < timeB) return -1;
    return 0;
}